import { defineStore } from 'pinia'
import { useGlobalStore } from '@/stores/global'

/**
 * Drives the AI assistant slideout: one panel instance mounted in AppLayout,
 * one launcher in the navbar, available on every Vue 3 page. The panel owns
 * its own data — this store only carries open/closed and the org gate.
 */
export const useAssistantStore = defineStore('assistant', {
  state: () => ({
    isOpen: false
  }),

  getters: {
    // Launcher, panel and shortcut all gate on this. Every assistant
    // endpoint is editor-only (AssistantPolicy), so a viewer gets no launcher
    // rather than a panel that 403s -- the same viewer gate navigation.js uses.
    available: () => {
      const globalStore = useGlobalStore()
      return globalStore.hasFeature('ai_assistant') && !globalStore.user.viewer
    }
  },

  actions: {
    open() {
      this.isOpen = true
    },
    close() {
      this.isOpen = false
    },
    toggle() {
      this.isOpen = !this.isOpen
    }
  }
})
